import React, { Component } from "react";
import { get, post } from "../services/api";
import { fetchUserCountry } from "../services/location";
import {
  NationalityOptions,
  SelectWeightClassOptions,
} from "../components/Options";
import nationaliies from "../data/nationalities.json";
import posthog from "posthog-js";
import { withRouter } from "react-router-dom";

const LB_TO_KG = 1 / 2.20462;

class AddLiftBase extends Component {
  state = {
    canSubmit: false,
    competition: null,
    competition_date: null,
    deadlift: 0,
    date_of_birth: "unknown",
    name: null,
    nationality: nationaliies[0],
    log: 0,
    weight_class: "Men Open",
    suggestions: [],
    suggestionsVisible: true,
    submitError: null,
    unit: localStorage.getItem('unit-preference') || 'kg',
  };

  componentDidMount = () => {
    posthog.capture("StartAddLift");
    fetchUserCountry().then(country => {
      this.setState({ nationality: country });
    });
  };

  componentDidUpdate = (nextProps, nextState) => {
    const { competition, deadlift, name, log, weight_class } = this.state;
    const fields = [competition, deadlift, name, log, weight_class];
    const is_not_empty = (value) => value !== null;
    const canSubmitNew = fields.every(is_not_empty);

    if (canSubmitNew !== nextState.canSubmit) {
      nextState.canSubmit = canSubmitNew;
      this.setState({ canSubmit: canSubmitNew });
    }
  };

  handleChange =
    (name) =>
    ({ target: { value } }) => {
      this.setState({ [name]: value });
    };

  handleNameChange = ({ target: { value } }) => {
    get(`api/athlete-suggestions?first_name_prefix=${value}`).then(
      ({ suggestions }) => {
        this.setState({ suggestions, suggestionsVisible: true });
      },
    );
    this.setState({ name: value });
  };

  dec2hex = (dec) => {
    return dec.toString(16).padStart(2, "0");
  };

  // generateId :: Integer -> String
  generateId = (len = 40) => {
    var arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2hex).join("");
  };

  getSessionId = () => {
    let sessionId = sessionStorage.getItem("dingDongSessionId") || undefined;
    if (sessionId) {
      return sessionId;
    }

    sessionId = this.generateId();
    sessionStorage.setItem("dingDongSessionId", sessionId);
    return sessionId;
  };

  getClientId = () => {
    let clientId = localStorage.getItem("dingDongClientId");
    if (clientId) {
      return clientId;
    }

    clientId = this.generateId();
    localStorage.setItem("dingDongClientId", clientId);
    return clientId;
  };

  handleBlur = () => {
    this.setState({ suggestionsVisible: false });
  };

  handleSubmit = () => {
    const {
      competition,
      competition_date,
      deadlift,
      date_of_birth,
      name,
      nationality,
      log,
      weight_class,
      unit,
    } = this.state;
    const client_id = this.getClientId();
    const session_id = this.getSessionId();

    const toKg = (value) => unit === 'lb'
      ? parseFloat((Number(value) * LB_TO_KG).toFixed(2))
      : Number(value);

    const data = {
      competition,
      competition_date,
      date_of_birth,
      deadlift: toKg(deadlift),
      name,
      nationality,
      log: toKg(log),
      weight_class,
      client_id,
      session_id,
    };

    this.setState({ submitError: null });
    post("api/lift", data).then((d) => {
      // reset values
      this.setState({ competition: "", log: 0, axel: 0, deadlift: 0 });
      // trigger an event so Home/ Profile components know to refresh data
      const event = new CustomEvent("add-lift");
      document.dispatchEvent(event);
      posthog.capture("AddLift", data);
      // navigate back to home
      this.props.history.push("/");
    }).catch((err) => {
      const detail = err?.response?.data?.detail;
      this.setState({
        submitError: typeof detail === "string" ? detail : "Failed to add lift. Please try again.",
      });
    });
  };

  render() {
    const {
      canSubmit,
      competition,
      competition_date,
      deadlift,
      date_of_birth,
      log,
      name,
      nationality,
      suggestions,
      submitError,
      suggestionsVisible,
      unit,
      weight_class,
    } = this.state;

    const inputClass =
      "w-full bg-[#F9FAFB] px-4 py-3 text-base font-bold uppercase tracking-wide text-stone-700 outline-none";
    const labelClass =
      "block text-xs font-bold uppercase tracking-[0.2em] text-stone-600 mb-2";

    return (
      <div className="min-h-screen bg-gray-100 px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="flex justify-end mb-4">
            <button
              className="px-5 py-2 text-sm font-bold tracking-[0.16em] uppercase bg-stone-300 text-stone-700 hover:bg-red-500 hover:text-white transition-colors duration-150"
              onClick={() => this.props.history.push("/")}
            >
              &larr; Back
            </button>
          </div>
          <div className="bg-white px-8 py-8 border-l-4 border-red-700">
          {/* Athlete Name */}
          <div className="mb-2 relative">
            <label className={labelClass}>Your name</label>
            <input
              className={inputClass}
              value={name || ""}
              onChange={this.handleNameChange}
              onBlur={() => setTimeout(this.handleBlur, 250)}
              placeholder="Search athlete database..."
            />
            {suggestionsVisible && suggestions.length > 0 && (
              <div className="absolute top-full left-0 right-0 z-10 bg-white border border-stone-200 mt-1">
                {suggestions.map((suggestion) => (
                  <button
                    key={suggestion.uid}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-[#F9FAFB] border-b border-stone-100 last:border-0"
                    onClick={() =>
                      this.setState({
                        name: suggestion.name,
                        date_of_birth: suggestion.date_of_birth,
                        nationality: suggestion.nationality,
                        gender: suggestion.gender,
                        suggestionsVisible: false,
                      })
                    }
                  >
                    <span className="font-bold">{suggestion.name}</span>
                    <span className="text-stone-500 text-xs ml-2">
                      {suggestion.nationality} · {suggestion.gender}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
          {/* <p className="text-xs font-bold uppercase tracking-[0.2em] text-red-600 mb-6">
            Verification required for elite level records
          </p>*/}
          {/* Unit toggle */}
          <div className="mb-4">
            <label className={labelClass}>Unit</label>
            <div className="inline-flex">
              {['kg', 'lb'].map((u) => (
                <button
                  key={u}
                  type="button"
                  className={`px-5 py-2 text-sm font-bold tracking-wide uppercase transition-colors duration-150 ${unit === u ? 'bg-red-500 text-white' : 'bg-[#F9FAFB] text-stone-700'}`}
                  onClick={() => this.setState({ unit: u })}
                >
                  {u}
                </button>
              ))}
            </div>
          </div>
          {/* Log + Deadlift */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <label className={labelClass}>Log ({unit})</label>
              <input
                className={inputClass}
                type="number"
                placeholder={`Weight in ${unit}`}
                value={log}
                onChange={this.handleChange("log")}
              />
            </div>
            <div>
              <label className={labelClass}>Deadlift ({unit})</label>
              <input
                className={inputClass}
                type="number"
                placeholder={`Weight in ${unit}`}
                value={deadlift}
                onChange={this.handleChange("deadlift")}
              />
            </div>
          </div>
          {/* Weight Class + Nationality */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <label className={labelClass}>Weight Class</label>
              <select
                className={inputClass}
                value={weight_class}
                onChange={this.handleChange("weight_class")}
              >
                <SelectWeightClassOptions />
              </select>
            </div>
            <div>
              <label className={labelClass}>Nationality</label>
              <select
                className={inputClass}
                value={nationality}
                onChange={this.handleChange("nationality")}
              >
                <NationalityOptions />
              </select>
            </div>
          </div>
          {/* Competition */}
          <div className="mb-6">
            <label className={labelClass}>Competition</label>
            <input
              className={inputClass}
              value={competition || ""}
              onChange={this.handleChange("competition")}
            />
          </div>
          {/* Date of Birth + Competition Date */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <label className={labelClass}>Date of Birth (optional)</label>
              <input
                className={inputClass}
                type="date"
                value={date_of_birth}
                onChange={this.handleChange("date_of_birth")}
              />
            </div>
            <div>
              <label className={labelClass}>Competition Date (optional)</label>
              <input
                className={inputClass}
                type="date"
                value={competition_date || ""}
                onChange={this.handleChange("competition_date")}
              />
            </div>
          </div>
          {/* Submit */}
          {submitError && (
            <p className="text-red-600 text-sm font-bold mb-2">{submitError}</p>
          )}
          <button
            className={`w-full py-4 text-sm font-bold tracking-[0.16em] uppercase text-white mt-2 ${canSubmit ? "bg-red-700" : "bg-stone-400"}`}
            onClick={() => this.handleSubmit()}
          >
            Submit Lift
          </button>
          {/* <p className="text-center text-xs tracking-[0.15em] uppercase text-stone-400 mt-6">
            Records are subject to technical review by sanctioning bodies.
          </p>*/}
          </div>
        </div>
      </div>
    );
  }
}

export const AddLift = withRouter(AddLiftBase);
